module.exports = __webpack_public_path__ + "img/cfc4711.jpg";